import clsx from "clsx";
import ErrorMessage from "@/components/ui/form/ErrorMessage";

interface RadioCardSelectorProps {
  isDescExpand?: boolean;
  options: ({
    id: string;
    title: string;
    description?: string;
    addition?: string;
  } & Record<string, unknown>)[];
  value: string | number | undefined;
  errorMessage?: string;
  onChange: (id: string | number) => void;
}

const RadioCardSelector = ({
  isDescExpand = false,
  options,
  value,
  errorMessage,
  onChange,
}: RadioCardSelectorProps) => {
  return (
    <div className="relative">
      <ol className="flex flex-col">
        {options.map((option, index) => {
          const isSelected = value === option.id;
          // Card
          return (
            <li
              key={option.id}
              onClick={() => onChange(option.id)}
              className={clsx(
                "brand-text-sm flex cursor-pointer items-center gap-4 bg-white p-4 pr-12 text-neutral shadow-[inset_0_0_0_1.5px_theme('colors.neutral-content')]",
                {
                  "z-10 !bg-info-content !shadow-[inset_0_0_0_1.5px_theme('colors.info')]":
                    isSelected,
                  "rounded-t-lg": index === 0,
                  "rounded-b-lg": index === options.length - 1,
                  "-mt-0.5": index !== 0,
                },
              )}
            >
              {/* Radio Style Element */}
              <div
                className={clsx(
                  "flex size-5 flex-shrink-0 items-center justify-center rounded-full border",
                  {
                    "border-info bg-info": isSelected,
                    "border-neutral-content": !isSelected,
                  },
                )}
              >
                {isSelected && <div className="size-2 rounded-full bg-white" />}
              </div>

              {/* Title, Desc, Addition */}
              <div className="flex flex-col">
                <div className="font-bold text-secondary">{option.title}</div>
                {(isSelected || isDescExpand) && (
                  <>
                    <div className="brand-text-xs">{option?.description}</div>
                    <div className="brand-text-sm mt-0.5 font-bold text-info">
                      {option?.addition}
                    </div>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ol>
      <ErrorMessage message={errorMessage} />
    </div>
  );
};

export default RadioCardSelector;
